import { Classes } from "@blueprintjs/core";
import omit from "lodash/omit";

import { allowBuyCredits } from "@/components/helpers/workspace/permissions";
import { Box, Flex } from "@/components/layout/flexbox";
import { NotFound } from "@/components/pages_public/404/NotFound";
import { AvailableCredits } from "@/components/pieces/coaching/available-credits/AvailableCredits";
import { getUser } from "@/components/session/JwtTokenManager";
import { CARD_CLASSES } from "@/css/constants";
import { useWorkspaceCreditsQuery, WorkspaceCreditsQuery } from "@/graphql";
import { SessionsUser } from "@/types/users";

function CreditsSkeleton() {
  return (
    <Flex
      py={3}
      px={[3, 24]}
      className={CARD_CLASSES}
      backgroundColor="#FFF"
      alignItems="center"
      justifyContent="space-between"
      css={{ gap: 12 }}
      flex={1}
      height={102}
    >
      <Box
        height={60}
        width={60}
        style={{ borderRadius: 100 }}
        className={Classes.SKELETON}
      />
      <Box flex={1}>
        <Box width={80} height={14} className={Classes.SKELETON} />
        <Box width={150} height={18} mt={2} className={Classes.SKELETON} />
      </Box>
      <Box height={36} width={130} className={Classes.SKELETON} />
    </Flex>
  );
}

interface WorkspaceCreditsProps {
  initData?: WorkspaceCreditsQuery;
  flex?: number;
}

export function WorkspaceCredits({ initData, flex }: WorkspaceCreditsProps) {
  const { data, loading } = useWorkspaceCreditsQuery({
    skip: !!initData,
  });

  const workspaceData = initData || data;
  const { currentWorkspaceCredits } = workspaceData || {
    currentWorkspaceCredits: "0",
  };

  const workspaceCreditUser = {
    availableCredits: currentWorkspaceCredits,
  };

  if (loading || !workspaceData) {
    return <CreditsSkeleton />;
  }

  const currentUser = getUser();

  if (!currentUser) return <NotFound />;

  const user: SessionsUser = {
    __typename: "UserType",
    ...omit(currentUser, "__typename"),
    ...workspaceCreditUser,
  };

  return (
    <AvailableCredits
      user={user}
      secondaryLabel={allowBuyCredits() ? "Buy Credits" : ""}
      secondaryLink="/buy"
      title="AVAILABLE TO DISBURSE"
      className={`${flex ? "flex-1" : ""}`}
    />
  );
}
